import React from 'react';
import './Card.scss';

const Card=(props)=>{
    return(
        <div className="hub-card">
            <div className="image-part" style={{ backgroundImage: `url(${props.bgImage})` }}></div>
            <div className="shade" style={{ background: `${props.background}` }}></div>
            {props.sub ? <h4>{props.icon ? <p>{props.icon}</p> : null} {props.sub}</h4> : null}
            {props.title ? <p>{props.title}</p> : null}
        </div>
    )
};
export default Card ;